import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import _ from 'lodash';
import hasUserInfo from '../../hocs/has-user-info';
import hasRESTClient from '../../hocs/has-rest-client';

import OrdersTable from '../orders-table';

const boxStyle = {
  paddingTop: 19,
  paddingBottom: 19,
};

class OrdersDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      orders: [],
      selectedCountry: 'UK',
    };
    const { buildRESTClient } = this.props;
    this.shareApiClient = buildRESTClient({
      baseURL: process.env.REACT_APP_SHARE_API_URL || '',
      timeout: 100000,
    });
  }

  componentDidMount = () => {
    this.requestData();
  }

  requestData = (reloading = false) => {
    const { selectedCountry } = this.state;

    const loadingKey = reloading ? 'isReloading' : 'isLoading';
    this.setState({
      [loadingKey]: true,
    });
    this.shareApiClient.get(`/affiliates/orders/${selectedCountry}`).then(response => {
      const orders = _.get(response, 'data.data.orders', []);
      this.setState({
        orders,
        [loadingKey]: false,
      });
    }).catch(err => {
      console.log('Error: ', err);
      this.setState({
        orders: [],
        [loadingKey]: false,
      });
    });
  }

  onCountrySelect = (event, { value }) => {
    const { isLoading } = this.state;
    if (isLoading) return;
    this.setState({
      selectedCountry: value,
    }, this.requestData);
  }
  render() {
    const {
      isLoading,
      isReloading,
      orders,
      selectedCountry,
    } = this.state;
    return (
      <div className="page">
        <div className="influencer-context-bar" style={boxStyle}>
          <div className="spacer small" />
          <div className="flex">
            <div className="item">
              <h1>Orders Dashboard</h1>
            </div>
            <div className="space" />
          </div>
          <div className="flex" >
            <div className="item">
              <h3 className="light">Abbott Lyon</h3>
            </div>
            <div className="item">
              <div className="horizontal-spacer" />
            </div>
            <div className="space" />
          </div>
        </div>
        <div className="page-content">
          <OrdersTable
            onCountrySelect={this.onCountrySelect}
            isLoading={isLoading}
            orders={orders}
            onReload={this.requestData}
            isReloading={isReloading}
            selectedCountry={selectedCountry}
          />
        </div>
      </div>
    );
  }
}

OrdersDashboard.propTypes = {
  userInfo: PropTypes.object.isRequired,
  buildRESTClient: PropTypes.func.isRequired,
};
export default compose(
  hasUserInfo,
  hasRESTClient,
)(OrdersDashboard);



/** WEBPACK FOOTER **
 ** ./src/containers/orders-dashboard/index.js
 **/